<template>
  <div class="performanceResultPc">
    <topmytitle title1=" 绩效考核结果查询" />
    <div class="select">
      <span class="year">年度选择</span>
      <el-date-picker
        v-model="year"
        type="year"
        placeholder="请选择年份"
        @change="selectYear"
        value-format="yyyy"
      >
      </el-date-picker>
    </div>
    <div class="resultTable">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="PERIOD" label="时间说明" width="180">
        </el-table-column>
        <el-table-column
          prop="C_PERF_LEVEL"
          label="绩效等级"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="C_EVALUATE_DESCR" label="评价">
        </el-table-column>
      </el-table>
    </div>
    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
  import { getPerformancet } from '../request/api';
  import topmytitle from '../components/topmytitle';
  import LoadingShow from '../components/loading';

  export default {
    name: 'performanceResultPc',
    components: {
      topmytitle,
      LoadingShow
    },
    data() {
      return {
        year: new Date().getFullYear() + '',
        tableData: [],
        loading: false
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      selectYear() {
        this.getData();
      },
      getData() {
        this.loading = true;
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          C_YEAR: this.year
        };
        getPerformancet(params)
          .then(res => {
            this.tableData = res.DATA || [];
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>

<style lang="less" scoped>
  .performanceResultPc {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .select {
    background-color: #fff;
    padding: 20px;
    .year {
      margin-right: 20px;
    }
  }
  .resultTable {
    padding: 10px;
    flex: 1;
    background-color: #fff;
    overflow: auto;
  }
</style>
